import React from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import { Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  root: {
    zIndex: "1310 !important"
  },
  title: {
    fontSize: "1.125rem",
    lineHeight: "1․25rem",
    fontWeight: 500,
    color: "#202124"
  }
}));

// TO2DO: find a way to keep single dialog

function UnsavedChangesDialog({
  open,
  handleClose,
  action,
  closeText = "Keep editing",
  actionText = "Discard",
  title = "You have unsaved changes",
  body = "Changes you made may not be saved"
}) {
  const classes = useStyles();

  const handleAction = () => {
    action();
    handleClose();
  };

  return (
    <Dialog
      maxWidth="xs"
      open={open}
      classes={{ root: classes.root }}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Box className={classes.title} px={3} pt={3} pb={2}>
        {title}
      </Box>

      <Box pb={1.5} px={3}>
        <Typography variant="body2">{body}</Typography>
      </Box>

      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus id='unsavedDialog-keepEdit'>
          {closeText}
        </Button>

        <Button onClick={handleAction} color="primary" id='unsavedDialog-discard'>
          {actionText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UnsavedChangesDialog;
